import userContext from '../../context/UserContext';
import { useContext, useMemo } from 'react';
import { PrivilegesContext } from '../../context/PrivilegesContext';

export default function PrivilegeBarrier({ privileges = [], excludeOnThese = [], children }) {
	const userPrivileges = useContext(PrivilegesContext);

	if (!privileges.some(p => userPrivileges.has(p))) return null;
	if (excludeOnThese.some(p => userPrivileges.has(p))) return null;

	return <>{children}</>;
}